import { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useMeasureHeight = (dependencies: any[]) => {
    const [height, setHeight] = useState<number>(0);
    const ref = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const measureHeight = () => {
            if (ref.current) {
                const rect = ref.current?.getBoundingClientRect();
                setHeight(rect.height);
            }
        };
        measureHeight();

        window.addEventListener('resize', measureHeight);

        return () => {
            window.removeEventListener('resize', measureHeight);
        };
    }, [dependencies]);

    return [height, ref] as const;
};
